
import { computed } from "vue";
import { useStore } from "vuex";
import { useToast } from "primevue/usetoast";
import router from "@/router";
import { useCurrentTime } from "../pages/useCurrentTime";

type MenuItem = {
  label: string;
  icon: string;
  to: string;
};

export default {
  props: {
    isLoggedIn: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    const store = useStore();
    const toast = useToast();
    const { currentTime } = useCurrentTime();

    const adminMenu: MenuItem[] = [
      { label: "Gởi tin nhắn", icon: "pi pi-send", to: "/sendmessage" },
      { label: "Đăng hình ảnh", icon: "pi pi-upload", to: "/uploadImage" },
      {
        label: "Nhân viên nhận báo cáo",
        icon: "pi pi-bars",
        to: "/addReceiverReportPage",
      },
      {
        label: "Nhân viên nhận thông báo CK",
        icon: "pi pi-dollar",
        to: "/addAccountantPage",
      },
      {
        label: "Nhân viên nhận TB té/ngã",
        icon: "pi pi-megaphone",
        to: "/addReceiverFallPage",
      },
      {
        label: "Danh sách đăng ký khám bệnh",
        icon: "pi pi-list",
        to: "/listRegisterService",
      },
      {
        label: "Thêm nhân viên hỗ trợ",
        icon: "pi pi-user-plus",
        to: "/addemployee",
      },
      {
        label: "Danh sách nhân viên",
        icon: "pi pi-users",
        to: "/showlistemployee",
      },
      { label: "Quản lý nhóm", icon: "pi pi-sitemap", to: "/managerGroup" },
      {
        label: "Quản lý nghỉ phép",
        icon: "pi pi-list-check",
        to: "/ShowListDayOff",
      },
      {
        label: "Cài đặt CheckIn",
        icon: "pi pi-map-marker",
        to: "/checkInGroup",
      },
      {
        label: "Nhận thông báo CheckIn",
        icon: "pi pi-cloud-download",
        to: "/addManagerCheckinPage",
      },
      { label: "Nhóm CheckIn", icon: "pi pi-ellipsis-h", to: "/timeGroupPage" },
      {
        label: "Xuất dữ liệu CheckIn",
        icon: "pi pi-file-export",
        to: "/showListCheckIn",
      },
      { label: "CheckIn hộ", icon: "pi pi-desktop", to: "/checkInByUserPage" },
      { label: "Gởi kết quả CLS", icon: "pi pi-send", to: "/sendFile" },
      {
        label: "Đăng ký tài khoản",
        icon: "pi pi-user-plus",
        to: "/registeruser",
      },
      { label: "Quản lý tài khoản", icon: "pi pi-users", to: "/userList" },
    ];

    const clsMenu: MenuItem[] = [
      { label: "Gởi kết quả CLS", icon: "pi pi-send", to: "/sendFile" },
    ];

    const menuItems = computed(() => {
      if (!store.state.token) return [];
      if (store.state.permission === "cls" || store.state.permission === "pk") {
        return clsMenu;
      }
      return adminMenu;
    });

    const logout = () => {
      store.dispatch("clearToken");
      store.dispatch("clearPermission");
      router.push({ name: "login" });
      toast.add({
        severity: "success",
        summary: "Đăng xuất",
        detail: "Đã xóa thông tin đăng nhập thành công",
        life: 1000,
      });
    };

    return {
      currentTime,
      logout,
      menuItems,
    };
  },
};
